/**
 * Pure helpers for bottom navigation (no DOM).
 */

export const BOTTOM_NAV_IDS = ['home', 'register', 'verify', 'scan', 'more'];

/**
 * @param {string} id
 * @returns {boolean}
 */
export function validateBottomNavTarget(id) {
  return BOTTOM_NAV_IDS.includes(id);
}

/**
 * Map bottom-nav id to work mode when applicable.
 * @param {string} navId
 * @returns {'register' | 'verify' | null}
 */
export function navIdToMode(navId) {
  if (navId === 'register') {
    return 'register';
  }

  if (navId === 'verify') {
    return 'verify';
  }

  return null;
}

/**
 * @param {'register' | 'verify'} mode
 * @returns {'register' | 'verify'}
 */
export function modeToNavId(mode) {
  return mode === 'verify' ? 'verify' : 'register';
}

/**
 * Which main panel should be visible for this nav id.
 *
 * Per the BPD (läge A vs. läge B) Home, Register and Verify are three
 * distinct screens:
 *   - Home   → pure dashboard (stats, last activity, violations, reports)
 *   - Register (läge A) → batch scan flow: car + wheels + 10/24 counters
 *   - Verify   (läge B) → read-only status with green/red per position
 *
 * @param {string} navId
 * @returns {'home' | 'work' | 'verify' | 'scan' | 'more'}
 */
export function navIdToPanelId(navId) {
  if (navId === 'scan') {
    return 'scan';
  }

  if (navId === 'more') {
    return 'more';
  }

  if (navId === 'verify') {
    return 'verify';
  }

  if (navId === 'register') {
    return 'work';
  }

  return 'home';
}

/**
 * @param {string} [hash]
 * @returns {typeof BOTTOM_NAV_IDS[number]}
 */
export function getNavSectionFromHash(hash) {
  const raw = String(hash ?? '').replace(/^#/, '').trim();
  if (!raw || raw === '/') {
    return 'home';
  }

  const section = raw.split('/')[0].split('?')[0];
  return validateBottomNavTarget(section) ? section : 'home';
}
